import { HTTP } from '@/services/axios';

export async function getUsers({filterText,filterGroups,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/User/getUserList.php',{
        params:{
            filterText,
            filterGroups,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function getUser({userId}){
    let result = {};
  
    await HTTP({
        method: 'get',
        url: `/app/core/User/getUserData.php?userId=${userId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getUserDataPswd(){
    let result = {};
    
    await HTTP.get('/app/core/UserChangePass/getUserPswdData.php')
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function unlockUser({userId}){
    let result = {};

    var data = {'myRecordID':userId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/User/controlUserUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function unblockUser({userId}){
    let result = {};

    var data = {'userId':userId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/User/controlUserUnBlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function resetAtemptsUser({userId}){
    let result = {};

    var data = {'userId':userId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/User/controlUserResetAttempts.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createUser({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/User/controlUserSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveUser({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/User/controlUserSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteUser({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/User/controlUserDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function checkDuplicityUser({email}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/User/getDuplicityUsers.php?email=${email}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getTypeOptions(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/User/getTypeOptions.php',
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getMultiOptions(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/User/getMultiOptions.php'
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getUserSysLogs({filterText,orderCol,orderSort,page,records,userId}){
    let result = {};
    
    await HTTP.get('/app/core/User/getSysLogsData.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records,
            userId
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getUserLogins({orderCol,orderSort,page,records,userId}){
    let result = {};
    
    await HTTP.get('/app/core/User/getLoginsData.php',{
        params:{
            orderCol,
            orderSort,
            page,
            records,
            userId
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

//user groups
export async function getUserGroups({userId}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/User/getUserGroupData.php?userId=${userId}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveUserGroup({data,userId}){
    let result = {};

    var datas = {'myGroups':data,'userId':userId};
    
    await HTTP({
        method: 'post',
        url: '/app/core/User/controlUserGroupSave.php',
        data: datas
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

//user password
export async function getUserPassData(){
    let result = {};

    var bodyFormData = new FormData();

    await HTTP({
        method: 'get',
        url: '/app/core/User/getUserPswdData.php',
        data: bodyFormData
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function savePass({p,userId}){
    let result = {};
  
    var data = {'p':p,'userId':userId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/User/controlUserPswdSave.php',
        data: data
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function generatePass(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/User/controlUserPswdGenerate.php'
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}